module.exports = __webpack_public_path__ + "static/img/avatar.2a17650.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.png
// module id = HfaK
// module chunks = 22